import styled from "styled-components";

export const InvoiceButton = styled.button`
  border: none;
  cursor: pointer;
  background: none;

  &:hover {
    background-color: #fff;
    opacity: 0.7;
    border-radius: 5px;
    border: 1px solid #f0292a;
  }
`;
